import { memo } from "react";
import './statusCircle.scss';

export interface StatusCircleProps {
    statusClass: string;
}

const StatusCircle = ({ statusClass }: StatusCircleProps) => {
    return (
        <span className={`status-circle ` + (statusClass)}>
        </span>
    );
};

export default memo(StatusCircle);